<template>
  <div class="auth-user-info">
    <strong>{{ fullName }}</strong>
    <span>{{ qualification ? (qualification + ' |') : '' }} {{ user.claveunica_id }} </span>
    <span v-if="user.logs.length > 0" style="padding-rop:6px;" :class="isCheque ? 'new-lines-cheque' : 'newlines'">Última actividad: {{ lastActivity }}</span>
    <span><a style="text-decoration: underline;cursor:pointer;" class="isCheque ? 'new-lines-cheque' : 'newlines'" @click="viewLogs = true">Ver detalles</a></span>

    <el-dialog
      title="Últimas actividades"
      width="60%"
      :before-close="handleCloseLogs"
      custom-class="medication-request-form__dialog"
      :visible="viewLogs">
      <table class="table" style="word-break: keep-all;">
        <thead>
          <tr>
            <th>Tipo de acceso</th>
            <th>IP</th>
            <th>Fecha y hora</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="log in user.logs" :key="log.id">
            <td style="max-width:400px;">
              {{ getBrowser(log.user_agent) }}
            </td>
            <td>{{ log.ip }}</td>
            <td>{{ log.created_at.split(' ').join(' a las ') }}</td>
          </tr>
        </tbody>
      </table>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'AuthUserInfo',
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      viewLogs: false
    };
  },
  computed: {
    fullName() {
      return `${this.user.given_name} ${this.user.family_name}`;
    },
    qualification() {
      return this.user.qualification;
    },
    lastActivity() {
      let last = (this.user.logs.length == 1) ? this.user.logs[0] : (this.user.logs[1]);
      return last.created_at.split(' ').join(' a las ');
    },
    isCheque() {
      return process.env.VUE_APP_RECETA_CHEQUE == 'true';
    }
  },
  methods: {
    handleCloseLogs() {
      this.viewLogs = false;
    },
    getBrowser(user_agent) {
      // Descartando safari primero

      if (user_agent.includes('Safari') && !user_agent.includes('Chrome')) {
        return 'Safari';
      }

      // Descartando opera

      if (user_agent.includes('OPR/')) {
        return 'Opera';
      }

      // Firefox
      if (user_agent.includes('Firefox')) {
        return 'Firefox';
      }

      // Edge
      if (user_agent.includes('Edg/') || user_agent.includes('Edge/')) {
        return 'Edge';
      }

      // Internet Explorer
      if (user_agent.includes('Trident')) {
        return 'Internet Explorer';
      }

      // Chrome
      if (user_agent.includes('Chrome')) {
        return 'Chrome';
      }

      return 'Navegador desconocido';
    }
  }
};
</script>

<style lang="scss">
  .auth-user-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    strong {
      line-height: 1.2;
      font-size: $--font-size-md;
      font-weight: 700;
    }

    span {
      font-size: $--font-size-sm;
      font-weight: 400;
    }

    .newlines {
      color: #97A2BA;
    }

    .new-lines-cheque {
      color: $--color-black;
    }
  }
  @media (max-width: 500px){
    .medication-request-form__dialog{
      width: 100%!important;
      .el-dialog__body{
        padding: 10px!important;
      }
      .table{
        font-size: 13px!important;
        td{
          padding: 5px!important;
        }
      }
    }
  }
</style>
